import * as React from "react";

import { ActivityType, useXO } from "../../../Common";

import { ReactPdpAnalyticsInterface } from "./analytics-interface";

export const useAnalyticsXO = (): ReactPdpAnalyticsInterface => {
  const { pushToTheDataLayer, consumerInitializationGuard } = useXO();

  const viewActionOnProduct: NonNullable<
    ReactPdpAnalyticsInterface["viewActionOnProduct"]
  > = React.useCallback(
    ({ productId }) => {
      let event: ActivityType = {
        action: "view",
        target: {
          product: `${productId}`,
        },
      };

      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const addToCartAction: NonNullable<
    ReactPdpAnalyticsInterface["addToCartAction"]
  > = React.useCallback(
    ({ productId, quantity }) => {
      const event: ActivityType = {
        action: "add-to-cart",
        target: {
          product: `${productId}`,
        },
        metadata: {
          quantity,
        },
      };

      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const initializedInterface: ReactPdpAnalyticsInterface = React.useMemo(
    () => ({
      hasInitialized: true,
      viewActionOnProduct,
      addToCartAction,
    }),
    [viewActionOnProduct, addToCartAction]
  );
  const analyticsInterface = consumerInitializationGuard({
    initializedInterface,
  });
  return analyticsInterface;
};
